// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body.payment_status_modal {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.modal-body.payment_status_modal img {
  margin-bottom: 1rem;
}
.modal-body.payment_status_modal h4 {
  color: #000;
}

.payment_status {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 1rem;
  background-color: #FFF;
  border-radius: 1rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  align-items: center;
  color: #000;
}
.payment_status h2 {
  color: #000;
}
.payment_status p {
  margin-bottom: 0;
}
.payment_status img {
  margin-bottom: 10px;
}
.payment_status.pfailed p {
  margin-bottom: 1rem;
}
.payment_status.pfailed ul li {
  list-style: none;
  position: relative;
  margin-bottom: 5px;
}
.payment_status.pfailed ul li:before {
  content: "";
  width: 7px;
  height: 15px;
  display: inline-block;
  border: none;
  border-bottom: 2px solid #6e6b7b;
  border-right: 2px solid #6e6b7b;
  position: absolute;
  transform: rotate(45deg);
  margin-left: -20px;
}

@media only screen and (min-width: 700px) {
  .payment_status {
    width: 600px;
    margin: 0 auto;
  }
}
.oacta ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}
.oacta ul li {
  list-style: none;
  width: calc(50% - 10px);
  margin-right: 10px;
}
.oacta ul li:last-child {
  margin-right: 0;
}
.oacta ul li a {
  background-color: rgb(10, 110, 190);
  color: #FFF;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 5px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/payment_status.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;AAGQ;EACI,WAAA;AADZ;;AAMA;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iDAAA;EACA,mBAAA;EACA,WAAA;AAHJ;AAKI;EACI,WAAA;AAHR;AAMI;EACI,gBAAA;AAJR;AAOI;EACI,mBAAA;AALR;AAUQ;EACI,mBAAA;AARZ;AAYY;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;AAVhB;AAYgB;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;AAVpB;;AAmBA;EACI;IACI,YAAA;IACA,cAAA;EAhBN;AACF;AAqBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAnBR;AAqBQ;EACI,gBAAA;EACA,uBAAA;EACA,kBAAA;AAnBZ;AAqBY;EACI,eAAA;AAnBhB;AAsBY;EACI,mCAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AApBhB","sourcesContent":[".modal-body {\r\n    &.payment_status_modal {\r\n        display: flex;\r\n        align-items: center;\r\n        flex-direction: column;\r\n\r\n        img {\r\n            margin-bottom: 1rem;\r\n        }\r\n\r\n        h4 {\r\n            color: #000;\r\n        }\r\n    }\r\n}\r\n\r\n.payment_status{\r\n    width: 100%;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 1rem;\r\n    background-color: #FFF;\r\n    border-radius: 1rem;\r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    align-items: center;\r\n    color: #000;\r\n\r\n    h2{\r\n        color: #000;\r\n    }\r\n\r\n    p{\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    img{\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    &.pfailed{\r\n\r\n        p{\r\n            margin-bottom: 1rem;\r\n        }\r\n\r\n        ul{\r\n            li{\r\n                list-style: none;\r\n                position: relative;\r\n                margin-bottom: 5px;\r\n\r\n                &:before{\r\n                    content: '';\r\n                    width: 7px;\r\n                    height: 15px;\r\n                    display: inline-block;\r\n                    border: none;\r\n                    border-bottom: 2px solid #6e6b7b;\r\n                    border-right: 2px solid #6e6b7b;\r\n                    position: absolute;\r\n                    transform: rotate(45deg);\r\n                    margin-left: -20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    \r\n}\r\n\r\n@media only screen and (min-width: 700px){\r\n    .payment_status{\r\n        width: 600px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n\r\n.oacta{\r\n    ul{\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 0;\r\n\r\n        li{\r\n            list-style: none;\r\n            width: calc(100%/2 - 10px);\r\n            margin-right: 10px;\r\n\r\n            &:last-child{\r\n                margin-right: 0;\r\n            }\r\n\r\n            a{\r\n                background-color: rgb(10, 110, 190);\r\n                color: #FFF;\r\n                padding: 5px 10px;\r\n                display: inline-block;\r\n                border-radius: 5px;\r\n                font-weight: 600;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
